import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const salesSlice = createSlice({
  name: "sales",
  initialState: {
    salesItems: [],
    sales: {},
    loading: false,
    error: null,
  },
  reducers: {
    setSalesItems: (state, action) => {
      state.salesItems = action.payload.data || [];
      state.loading = false;
    },
    setSales: (state, action) => {
      state.sales = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectSalesLoading = (state) => state.sales.loading;
export const selectSalesError = (state) => state.sales.error;
export const selectSalesItems = (state) => state.sales.salesItems;
export const selectSales = (state) => state.sales.sales;

// Export the reducer to include in the store
export const { setSales, setSalesItems } = salesSlice.actions;
export default salesSlice.reducer;
